import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import ImageUpload from './ImageUpload';
import ErrorContainer from '../ErrorContainer';

class ImageUploadWithErrorContainer extends React.Component {
  static propTypes = {
    label: PropTypes.node.isRequired,
    touched: PropTypes.bool,
    required: PropTypes.bool,
    crop: PropTypes.object,
    error: PropTypes.any
  };
  render() {
    let {label, touched, required, error, crop} = this.props;

    let newLabel = crop
      ? ( <span>{label}
          <br/>
      <small style={{fontSize: 14, fontWeight: 'normal'}}>(<FormattedMessage
        id="form.image_upload.minimum_size"
        defaultMessage="Minimum size {width} x {height} px"
        values={crop}
      />)</small>
      </span>
  )
    : label;

    if (error) {
      error = error instanceof Array ? error : [error];
    }

    return (
      <ErrorContainer label={newLabel}
                      touched={touched}
                      error={error}
                      required={required}>
        <ImageUpload {...this.props}/>
      </ErrorContainer>
    );
  }
}

export default ImageUploadWithErrorContainer;





// WEBPACK FOOTER //
// ./src/components/form/ImageUpload/ImageUploadWithErrorContainer.js